// extracted by mini-css-extract-plugin
module.exports = {"tabList":"ProductTabList_tabList__6PoNz","tab":"ProductTabList_tab__3ypsI","activeTab":"ProductTabList_activeTab__2Kxi4"};